/**
 * Configurator API
 * Configurator API documentation
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface HavingCountTable {
    tableName?: string;
    operator?: HavingCountTable.OperatorEnum;
    value1?: number;
    value2?: number;
    autoConditions?: { [key: string]: any; };
}
export namespace HavingCountTable {
    export type OperatorEnum = 'EQUALS' | 'LESS_THAN' | 'GREATER_THAN' | 'NONE' | 'RANGE';
    export const OperatorEnum = {
        EQUALS: 'EQUALS' as OperatorEnum,
        LESSTHAN: 'LESS_THAN' as OperatorEnum,
        GREATERTHAN: 'GREATER_THAN' as OperatorEnum,
        NONE: 'NONE' as OperatorEnum,
        RANGE: 'RANGE' as OperatorEnum
    };
}
